import { useEffect, useState } from 'react';
import { styled } from 'styled-components';

import { _useSelector, _useDispatch } from '@src/state/hooks';
import { onSelectGameTypes } from '@src/state/slices/slice_lobby';

import Header from '@src/components/Lobby/Header';
import List from '@src/components/Lobby/List';
import CreateGamePlanel from '@src/components/Lobby/CreateGamePanel';
import JoinPrivateGamePanel from '@src/components/Lobby/JoinPrivateGamePanel';
import ConfirmJoinGamePanel from '@src/components/Lobby/ConfirmJoinGamePanel';

import ChatWidget from '@src/components/ChatWidget';

import bg from '@src/asset/background/10042.png';

const Container = styled.div`
  width: 100%;
  max-height: 100%;

  display: flex;
  flex-grow: 1;

  align-items: stretch;
  justify-content: flex-start;

  flex-direction: column;

  background-image: url(${bg});
  background-repeat: repeat;

  overflow: hidden;
`;

export default function Lobby() {
  const dispatch = _useDispatch();
  const gameTypes = _useSelector((state) => state.lobby.gameTypes);
  const isConnected = _useSelector((state) => state.app.isConnected);
  const chat = _useSelector((state) => state.app.chat.lobby);

  const [state, setState] = useState<{
    showCreateGamePanel: boolean;
    showJoinPrivateGamePanel: boolean;
    showConfirmJoinGamePanel: boolean;
    pendingGameId: string | null;
    pendingGameWager: number | null;
    pendingGameName: string | null;
  }>({
    showCreateGamePanel: false,
    showJoinPrivateGamePanel: false,
    showConfirmJoinGamePanel: false,
    pendingGameId: null,
    pendingGameWager: null,
    pendingGameName: null,
  });

  useEffect(() => {}, [isConnected]);

  const onPressCreate = () => {
    setState({
      showCreateGamePanel: true,
      showJoinPrivateGamePanel: false,
      showConfirmJoinGamePanel: false,
      pendingGameId: null,
      pendingGameWager: null,
      pendingGameName: null,
    });
  };

  const doshowJoinPrivateGamePanel = (
    gameId: string,
    gameName: string,
    gameWager: number,
  ) => {
    setState({
      showCreateGamePanel: false,
      showJoinPrivateGamePanel: true,
      showConfirmJoinGamePanel: false,
      pendingGameId: gameId,
      pendingGameWager: gameWager,
      pendingGameName: gameName,
    });
  };

  const doShowConfirmJoinGamePanel = (
    gameId: string,
    gameName: string,
    gameWager: number,
  ) => {
    setState({
      showCreateGamePanel: false,
      showJoinPrivateGamePanel: false,
      showConfirmJoinGamePanel: true,
      pendingGameId: gameId,
      pendingGameWager: gameWager,
      pendingGameName: gameName,
    });
  };

  const hideshowJoinPrivateGamePanel = () => {
    setState({
      showCreateGamePanel: false,
      showJoinPrivateGamePanel: false,
      showConfirmJoinGamePanel: false,
      pendingGameId: null,
      pendingGameWager: null,
      pendingGameName: null,
    });
  };

  const hideConfirmJoinGamePanel = () => {
    setState({
      showCreateGamePanel: false,
      showJoinPrivateGamePanel: false,
      showConfirmJoinGamePanel: false,
      pendingGameId: null,
      pendingGameWager: null,
      pendingGameName: null,
    });
  };

  const hideCreateGamePanel = () => {
    setState({
      showCreateGamePanel: false,
      showJoinPrivateGamePanel: false,
      showConfirmJoinGamePanel: false,
      pendingGameId: null,
      pendingGameWager: null,
      pendingGameName: null,
    });
  };

  return (
    <Container>
      <Header gameTypes={gameTypes} onPressCreate={onPressCreate} />
      {state.showCreateGamePanel &&
        !state.showJoinPrivateGamePanel &&
        !state.showConfirmJoinGamePanel && (
          <CreateGamePlanel onPressBack={hideCreateGamePanel} />
        )}
      {state.showJoinPrivateGamePanel &&
        !state.showCreateGamePanel &&
        !state.showConfirmJoinGamePanel && (
          <JoinPrivateGamePanel
            gameId={state.pendingGameId!}
            gameName={state.pendingGameName!}
            gameWager={state.pendingGameWager!}
            onPressBack={hideshowJoinPrivateGamePanel}
          />
        )}
      {state.showConfirmJoinGamePanel &&
        !state.showCreateGamePanel &&
        !state.showJoinPrivateGamePanel && (
          <ConfirmJoinGamePanel
            gameId={state.pendingGameId!}
            gameName={state.pendingGameName!}
            gameWager={state.pendingGameWager!}
            onPressBack={hideConfirmJoinGamePanel}
          />
        )}
      <List
        gameTypes={gameTypes}
        onPressGameTypes={(gameTypes) => dispatch(onSelectGameTypes(gameTypes))}
        showJoinPrivateGamePanel={doshowJoinPrivateGamePanel}
        showConfirmJoinGamePanel={doShowConfirmJoinGamePanel}
      />
      <ChatWidget
        room='lobby'
        chat={chat || []}
        chatboxPosition='top'
        initialChatboxVisible={false}
        initialChatMuted={true}
      />
    </Container>
  );
}
